<template>
    <div class="flex" v-bind:class="{ 'theme-bdr--red':  !range.isValid() }">
        <time-select v-model="range.startTime" @input="updateParent" dusk="start-time-select" class="start-time-select m-r-sm"></time-select>
        <time-select v-model="range.endTime" @input="updateParent" dusk="end-time-select" class="end-time-select"></time-select>
    </div>
</template>

<script>
import TimeSelect from './time-select';

export default {
    props: {
        value: Object
    },
    data() {
        return {
            range: this.value
        }
    },
    methods: {
        updateParent(time) {
            this.$emit('input', this.range);
        }
    },
    watch: {
        value() {
            this.range = this.value;
        }
    },
    components: {
        TimeSelect
    }
}
</script>

<style>
    .start-time-select {
        width: 50%;
    }

    .end-time-select {
        width: 50%;
    }
</style>
